import React from 'react';
import CookingQuantityLabel from './CookingQuantityLabel';

interface CookingQuantityCapsuleProps {
    quantity: number;
    unit: string;
    t: (k: string) => string;
    rtl?: boolean;
    isMeat?: boolean;
    struck?: boolean;
    variant?: 'default' | 'inline';
}

const CookingQuantityCapsule: React.FC<CookingQuantityCapsuleProps> = ({
    quantity,
    unit,
    t,
    rtl = false,
    isMeat = false,
    struck = false,
    variant = 'default',
}) => {
    const directionClass = rtl ? 'rtl:text-right' : 'ltr:text-left';

    if (variant === 'inline') {
        return (
            <span dir={rtl ? 'rtl' : 'ltr'} className={`inline-flex items-baseline gap-0.5 whitespace-nowrap ${directionClass}`}>
                <CookingQuantityLabel
                    quantity={quantity}
                    unit={unit}
                    t={t}
                    rtl={rtl}
                    isMeat={isMeat}
                    struck={struck}
                    variant="inline"
                />
            </span>
        );
    }

    return (
        <span
            dir={rtl ? 'rtl' : 'ltr'}
            className={`
                flex-shrink-0 self-start inline-flex items-center justify-center gap-0.5
                rounded-lg px-2.5 py-1 min-w-[3rem] min-h-8
                border select-none whitespace-nowrap ${directionClass}
                ${struck
                    ? 'bg-slate-50 dark:bg-slate-900 border-slate-100 dark:border-slate-800 opacity-60'
                    : isMeat
                        ? 'bg-rose-50 dark:bg-rose-900/30 border-rose-100 dark:border-rose-900'
                        : 'bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-700'}
            `.trim()}
        >
            <CookingQuantityLabel
                quantity={quantity}
                unit={unit}
                t={t}
                rtl={rtl}
                isMeat={isMeat}
                struck={struck}
                variant="default"
            />
        </span>
    );
};

export default CookingQuantityCapsule;
